/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the WaitlistSignupRequest interface.
 */
export function instanceOfWaitlistSignupRequest(value) {
    if (!('email' in value) || value['email'] === undefined)
        return false;
    return true;
}
export function WaitlistSignupRequestFromJSON(json) {
    return WaitlistSignupRequestFromJSONTyped(json, false);
}
export function WaitlistSignupRequestFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'brand': json['brand'] == null ? undefined : json['brand'],
        'documentVersion': json['documentVersion'] == null ? undefined : json['documentVersion'],
        'email': json['email'],
        'locale': json['locale'] == null ? undefined : json['locale'],
    };
}
export function WaitlistSignupRequestToJSON(json) {
    return WaitlistSignupRequestToJSONTyped(json, false);
}
export function WaitlistSignupRequestToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'brand': value['brand'],
        'documentVersion': value['documentVersion'],
        'email': value['email'],
        'locale': value['locale'],
    };
}
